import { Type, type Static } from '@sinclair/typebox';
import { MinimalUser, minimalUserSchema } from '../../shared/user/user.schema';

export const groupParticipantSchema = Type.Object({
  object: Type.Literal('GroupParticipant'),
  user: Type.Object(minimalUserSchema, { description: 'The user who is a participant of the group.' }),
  is_self: Type.Boolean({ description: 'Is the current user the participant.' }),
  is_admin: Type.Boolean({ description: 'Is the participant an admin of the group.' }),
});

export type GroupParticipant<UserSpecifics = unknown> = Omit<Static<typeof groupParticipantSchema>, 'user'> & {
  user: MinimalUser<UserSpecifics>;
};
